import grid from './grid/index.js'

const getInitState = () => {
  return {
    dialog: {
      visible: false,
      appendToBody: true,
      modal: true,
      width: '800px',
      top: '88px',
      uuid: '',
      onReplaced: () => {},
    },
    supportPlayUnit: false,
    dialogStyle: {
      left: '',
      right: '',
    },
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  getters: {},

  mutations: {
    /**
     * @param category {string}
     * @param action {string} 枚举值有 add、update
     * @param subCategory {string} 子分类，枚举值有 bg：背景图片
     */
    openDialog(state, { uuid } = {}) {
      state.dialog.uuid = uuid
      state.dialog.visible = true
    },

    updateSupportPlayUnit(state, status = false) {
      state.supportPlayUnit = status
    },

    closeDialog(state) {
      state.dialog.visible = false
      state.dialog.uuid = ''
    },
  },

  actions: {},

  modules: {
    grid,
  },
}
